import styles from "./styles.module.scss";
import { cn } from "@/lib/utils";

const getUsageColor = (percentage: number, backgroundBar: boolean) => {
  let r, g, b;

  if (percentage <= 50) {
    // #EE140F -> #FF754C
    r = Math.round(238 + (percentage / 50) * (255 - 238));
    g = Math.round(20 + (percentage / 50) * (117 - 20));
    b = Math.round(15 + (percentage / 50) * (76 - 15));
  } else {
    // #FF754C -> #237efe
    percentage -= 50;
    r = Math.round(255 + (percentage / 50) * (35 - 255));
    g = Math.round(117 + (percentage / 50) * (126 - 117));
    b = Math.round(76 + (percentage / 50) * (254 - 76));
  }

  if (backgroundBar) return `rgba(${r}, ${g}, ${b}, 0.1)`;
  return `rgba(${r}, ${g}, ${b}, 1)`;
};

export const UsagePercentageBar = ({ usagePercentage }: { usagePercentage: number }) => {
  const displayPercentage = Math.min(usagePercentage, 100);
  return (
    <div className={styles.usage}>
      <div className={styles.usage_bar}>
        <div className={styles.bar}>
          <div
            className={cn(styles.background_bar)}
            style={{ background: getUsageColor(displayPercentage, true) }}
          >
            <div
              className={styles.percentage_bar}
              style={{
                width: `${displayPercentage}%`,
                background: getUsageColor(displayPercentage, false),
              }}
            />
          </div>
        </div>
      </div>
      <div className={styles.percentage_text}>{usagePercentage + "%"}</div>
    </div>
  );
};
